// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2NcmS","left":"InfoRow_left__k93n8"};